import { COLORS, colors } from '@constants/colors';
import { useTheme } from '@mui/material';
import { ScreenSizes } from '@interfaces';
import { useMytaverse } from '@providers/MytaverseProvider';

export const useStyles = () => {
  const { breakpoints } = useTheme();
  const { appTheme } = useMytaverse();

  return {
    root: {
      p: 0,
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',
      width: '100%',
      '& .MuiCheckbox-root': {
        color: colors.white,
      },
      '& .Mui-checked': {
        color: appTheme.mainColor,
      },
    },

    icon: {
      color: COLORS.LIGHT_GREY,
    },

    generalButton: {
      display: 'flex',
      alignItems: 'center',
      mt: 3,
      justifyContent: 'center',
    },
    slider: {
      width: 'calc(100% - 6px)',
      mb: 2,
      '& .MuiSlider-root': {
        padding: '10px 0',
      },
      '& span': {
        color: appTheme.mainColor,
      },
      '& .MuiSlider-thumb': {
        width: 12,
        height: 12,
      },
      '& .MuiSlider-thumb:after': {
        width: 24,
        height: 24,
      },
      '& .MuiSlider-rail': {
        backgroundColor: colors.grey_third,
      },
      '& .MuiSlider-track': {
        border: 0,
      },

      [breakpoints.down(ScreenSizes.Pc)]: {
        width: '94%',
      },
    },
    label: {
      color: colors.white,
      fontWeight: 500,
      fontSize: 14,
      lineHeight: 1.5,
      letterSpacing: '0.02em',
      marginBottom: 0.5,
    },
    buttonOptions: { mb: 3 },
  };
};
